import React, { useEffect, useState } from 'react';
import ConsentModal from './ConsentModal';
import { consentPayload } from './legalConfig';
import { screenMessage } from '../lib/screenMessage';

/** Mount once inside the auth provider. When a signed-in user's accepted
 *  terms/privacy version is older than the current one, shows a blocking
 *  re-consent modal. `api` = the app's axios instance (baseURL ends in /api). */
export default function LegalGate({ api, user, onSignOut }) {
  const [status, setStatus] = useState(null);
  const uid = user && (user.id || user.user_id || user._id);
  useEffect(() => {
    let off = false;
    setStatus(null);
    if (!uid) return undefined;
    api.get('/legal/consent-status').then(({ data }) => { if (!off) setStatus(data); }).catch(() => {});
    return () => { off = true; };
  }, [api, uid]);
  if (!status || !status.consent_required) return null;
  return (
    <ConsentModal
      open
      mode="reconsent"
      effectiveDate={status.consent && status.consent.effective_date}
      onAccept={async (c) => {
        try {
          await api.post('/legal/consent', consentPayload(c));
          setStatus(null);
        } catch {
          throw new Error(screenMessage('login'));
        }
      }}
      onCancel={onSignOut}
    />
  );
}

/** For OAuth callbacks: finish a held sign-up after the consent step. Returns the login payload. */
export async function completeOAuthSignup(api, pendingToken, consent) {
  const { data } = await api.post('/auth/oauth/complete-signup', {
    pending_signup_token: pendingToken, ...consentPayload(consent),
  });
  return data;
}
